import React from "react";
import { EditableText } from "./live/Editable";

export default function PageHero({ title, subtitle, kicker, path }) {
  const p = path || "";
  return (
    <section className="relative gradient-hero text-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-10 w-72 h-72 bg-yellow-400/20 animate-blob blur-3xl" />
        <div className="absolute bottom-0 right-20 w-80 h-80 bg-blue-400/20 animate-blob blur-3xl" style={{ animationDelay: "2s" }} />
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
            backgroundSize: "50px 50px",
          }}
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        {kicker && (
          <EditableText
            path={p ? `${p}.kicker` : "pagehero.kicker"}
            as="p"
            className="inline-block px-3 py-1 rounded-full bg-yellow-400/20 border border-yellow-400/40 text-yellow-300 text-xs font-bold tracking-wider uppercase mb-4"
          >
            {kicker}
          </EditableText>
        )}
        <EditableText
          path={p ? `${p}.title` : "pagehero.title"}
          as="h1"
          className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-4 max-w-3xl animate-fade-up"
        >
          {title}
        </EditableText>
        {subtitle && (
          <EditableText
            path={p ? `${p}.subtitle` : "pagehero.subtitle"}
            as="p"
            multiline
            className="text-lg text-slate-200 max-w-2xl animate-fade-up"
          >
            {subtitle}
          </EditableText>
        )}
      </div>
      <svg className="absolute bottom-0 w-full" viewBox="0 0 1440 80" preserveAspectRatio="none" style={{ height: 60 }}>
        <path fill="#ffffff" d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z" />
      </svg>
    </section>
  );
}
